import React from "react";
import img from "Common/img/BCI Logo.png";
import nextId from "react-id-generator";
import { setPrefix } from "react-id-generator";

export default class CommonErrorPage extends React.Component {
  constructor(props) {
    super(props);
    /*this.state = {
                    error: null
                };*/
    setPrefix("CommonErrorPage-");
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.title = "Next-GenProservice";
  }

  handleClick() {
    console.log("Common");
    window.location.reload(true);
  }

  render() {
    return (
      <div className="ErrorMessage01">
        <table width="990px" align="center">
          <tbody>
            <tr>
              <td>
                Please call your local IT Support number or raise remedy ticket
                and assign to PROService team, to report the below error Error
                Code: 1973637
              </td>
            </tr>

            <tr>
              <td>
                {" "}
                {
                  <a id={nextId()} href="" onClick={this.handleClick}>
                    [refresh]
                  </a>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
